class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.thumbnail = this.querySelectorAll('.product-thumbnails-element');

    if (!this.slider) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton ? this.prevButton.addEventListener('click', this.onButtonClick.bind(this)) : '';
    this.nextButton ? this.nextButton.addEventListener('click', this.onButtonClick.bind(this)) : '';

    for (let i = 0; i < this.thumbnail.length; i++) {
      this.thumbnail[i].addEventListener("click", this.thumbnailClick.bind(this));
    }

    this.updateProductThumbnailsMaxHeight();
    this.autoplay();
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
	this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', true);
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', true);
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  thumbnailClick(event) {
	  event.preventDefault();
	  this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;
	  const clickedElement = Number(event.srcElement.parentNode.dataset.imageThumbnail);
	  
	  const difference = clickedElement - this.currentPage;
	  if ( difference !== 0 ) {
		const newPosition = difference > 0 ? this.slider.scrollLeft + this.sliderItems[0].clientWidth * difference : difference < 0 ? this.slider.scrollLeft - this.sliderItems[0].clientWidth * (difference * -1) : null;

		this.slider.scrollTo({
			left: newPosition
		});
	  }
  }

  onButtonClick(event) {
    event.preventDefault();
	  const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  updateProductThumbnailsMaxHeight(){
    if (window.innerHeight > 750) {
      let productThumbnailsContainer = this.querySelector('.product__thumbnail-images-container.product__thumbnail-images-container--large-thumbs .product-thumbnails-container');
      if (productThumbnailsContainer) {
        let productMainSlider = this.querySelectorAll('.product__thumbnail-images-container .product__media-list .product__media-item')[0];
        let productMainSliderHeight = productMainSlider.offsetHeight;
        productThumbnailsContainer.style.maxHeight = `${productMainSliderHeight}px`;

        window.addEventListener("resize", () => {
          let productMainSliderHeight = productMainSlider.offsetHeight;
          productThumbnailsContainer.style.maxHeight = `${productMainSliderHeight}px`;
        });
      }
    }
  }
  autoplay(){
    const self = this;
    const sliderLength = self.querySelectorAll('.slider__slide').length;
    let currSlide = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;
    let scrollDirection = 'next';

    if(self.classList.contains('autoplay')){
      setInterval(() => {
        const slideScrollPosition = scrollDirection === 'next' ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
        this.slider.scrollTo({
          left: slideScrollPosition
        });
        currSlide = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1
        if (currSlide == 1) {
          scrollDirection = 'next';
        }else if(currSlide == sliderLength) {
          scrollDirection = 'prev';
        }
      }, 2000);
    }
  }
}

customElements.define('slider-component', SliderComponent);
